import MasterVendor from "./Vendor";

export default MasterVendor;
